<ng-container *ngIf="options$ | async as options">
    <div class="inline-select__list-options" [ngClass]="{open: showDropdown}">
        <div class="inline-select__option" *ngIf="!showDropdown" (click)="toggleDropdown()">
            <ng-container *ngIf="getSelected() as selected; else defaultOption">
                <span class="icon-wrapper" *ngIf="useIcons"><i class="{{ selected.icon }}"></i></span>
                <span class="label label--placeholder">{{ selected.label }}</span>
            </ng-container>
            <ng-template #defaultOption>
                <span class="label">{{ placeholderSelect() }}</span>
            </ng-template>
            <i class="fa fa fa-caret-down"></i>
        </div>

        <div
            class="inline-select__option"
            *ngFor="let option of options; trackBy: trackByValue"
            [ngClass]="{selected: isSelected(option)}"
            (click)="onOptionClick(option)"
        >
            <span class="icon-wrapper" *ngIf="useIcons"><i class="{{ option.icon }}"></i></span>
            <span class="label">{{ option.label }}</span>
            <i class="fa fa-check"></i>
        </div>
    </div>
    <div class="inline-select__overlay" *ngIf="showDropdown" (click)="this.showDropdown = false"></div>
</ng-container>
